import { render, staticRenderFns } from "./FilterTrucks.vue?vue&type=template&id=3de23c70&scoped=true"
import script from "./FilterTrucks.vue?vue&type=script&lang=js"
export * from "./FilterTrucks.vue?vue&type=script&lang=js"
import style0 from "./FilterTrucks.vue?vue&type=style&index=0&id=3de23c70&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de23c70",
  null
  
)

export default component.exports